export function getMediaUrl(id) {
  return `/api/media/${id}`;
}

export async function getMyMedia() {
  const res = await fetch("/api/media/my", { credentials: "include" });
  const data = await res.json().catch(() => []);
  if (!res.ok) throw new Error(data?.error || "Erreur chargement galerie");
  return data;
}

export async function uploadImage(file, zone = "gallery", label = "") {
  const formData = new FormData();
  formData.append("file", file);
  if (label) formData.append("label", label);

  const res = await fetch(`/api/media/upload?zone=${zone}`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Upload échoué");
  return { ID_media: data.ID_media, public_id: data.public_id };
}

export async function updateLabel(id, label) {
  const res = await fetch(`/api/media/${id}/label`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ label }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Mise à jour échouée");
  return data;
}

export async function deleteMedia(id) {
  const res = await fetch(`/api/media/${id}`, {
    method: "DELETE",
    credentials: "include",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Suppression échouée");
  return data;
}

export function triggerSingleDownload(id, filename) {
  const a = document.createElement("a");
  a.href = `/api/media/${id}/download`;
  a.download = filename || `photo-${id}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export async function downloadMediaZip(ids) {
  const res = await fetch("/api/media/download-zip", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ids }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.message || "Téléchargement échoué");
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "photos.zip";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export async function uploadAvatar(file) {
  const { ID_media: id } = await uploadImage(file, "avatar", "");
  const res = await fetch("/api/profile", {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ users_avatar_id: id }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Mise à jour avatar échouée");
  return { ID_media: id, user: data };
}

export async function uploadCover(file) {
  const { ID_media: id } = await uploadImage(file, "cover", "");
  const res = await fetch("/api/profile", {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ users_cover_id: id }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Mise à jour couverture échouée");
  return { ID_media: id, user: data };
}

export async function setCoverFromGallery(mediaId) {
  const res = await fetch("/api/profile", {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ users_cover_id: mediaId }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Mise à jour couverture échouée");
  return data;
}
